const mixpanel = require('mixpanel-browser');

class MixpanelEvents {
  /**
   * Adiciona um callback com evento do mixpanel a outro evento, para isso o
   * elemento que contém o elemento principal deve conter um data-callback comm
   * o id do elemento que tera o evento secundario
   *
   * @param idCallback
   * @param eventName
   */
  addCallBack(idCallback, eventName) {
    const elementCallback = document.getElementById(idCallback);
    const event = eventName + '-' + idCallback;
    if (elementCallback.tagName === 'FORM') {
      return () => {
        mixpanel.track_forms(elementCallback, event);
      }
    }
    return () => {
      mixpanel.track(event);
    }
  }

  /**
   * Adiciona evento do mixpanel a um input quando ele recever foco ou seja, ser
   * clicado , para isso o input tem q conter o data-focus true além dos outros
   * atributos
   *
   * @param $element
   * @param eventName
   */
  addEventFocus($element, eventName, callback) {
    let contadorClick = 0;
    $element.focus('focus', (e) => {
      if (contadorClick === 0) {
        mixpanel.track(eventName, null, callback);
      }
      contadorClick++;
    });
  }

  /**
   * Adiciona evento do mixpanel ao clicar no elemento
   *
   * @param    $element
   * @param    eventName
   * @param    callback
   */
  addEventClick($element, eventName, callback) {
    $element.on('click', function () {
      mixpanel.track(eventName, null, callback);
    });
  }

  /**
   * Adiciona evento do mixpanel ao form
   *
   * @param $element
   */
  addEventForm($element, callback = null) {
    const eventName = this.getPage() + $element.attr('data-event');

    mixpanel.track(eventName, null, callback);
  }

  /**
  * obtém o ultimo elemento da url atual
  *
  * @return String
  */
  getPage() {
    const url = window.location.href;
    const arrayUrl = url.split('/');
    const page = arrayUrl[arrayUrl.length - 1].split('#');
    return page[0].replace(/[?!@#$%&]/gi, '').toUpperCase();
  }

  addParamsPeople(paramName, url) {
    return  () => {
      this.sendRequest('GET', url)
        .done(function(data) {
          console.log('a');
          mixpanel.people.append(paramName, Object.keys(data).length);
        })
        .fail(function(error) {
          console.log(error);
        })
    }
  }

  sendRequest(method, url, data = null) {
    return $.ajax({
      method: method,
      url: url,
      data: data
    });
  }
}

export default MixpanelEvents;
